export default __webpack_public_path__ + "static/media/money.86aec142.svg";